import { TandemTool } from "../../base/TandemTool.js";
import { logger } from "../../../../../../core/logger.js";

export class ListDirectoryTool extends TandemTool {
  constructor() {
    super();
    this.toolName = "listDirectoryTool";
  }

  /**
   * @param {string} path
   * @param {boolean} [recursive=false]
   * @param {boolean} [includeStats=false]
   * @param {boolean} [includeHidden=false]
   * @returns {Promise<Object>}
   */
  async listDirectory(
    path,
    recursive = false,
    includeStats = false,
    includeHidden = false
  ) {
    try {
      if (!path || typeof path !== "string") {
        return this.returnError({}, "Valid directory path required");
      }

      const api = this.getTandemLocalAppApi();
      if (!api?.listDirectory) {
        return this.returnError(
          {},
          "Tandem directory listing requires Revolt Desktop (tandemAPI.listDirectory)."
        );
      }

      const root = this.getTandemWorkingDirectoryRoot();
      if (!root) {
        return this.returnError(
          {},
          "Tandem has no project folder set (working directory path)."
        );
      }

      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      let relativePath = normalizedPath.replace(/^\/+/, "");
      if (relativePath === "") {
        relativePath = ".";
      }

      if (relativePath !== "." && relativePath.includes("..")) {
        return this.returnError({}, "Invalid directory path");
      }

      const res = await api.listDirectory({
        rootPath: root,
        relativePath,
        recursive,
        includeStats,
        includeHidden,
      });

      if (!res?.success) {
        return this.returnError({}, res?.error || "Failed to list directory on disk");
      }

      logger.log(
        { tags: "tools|tandem|listdir|info", color1: "lime" },
        `Tandem listed directory: ${normalizedPath}`,
        { entryCount: res.count }
      );

      return this.returnSuccess(
        {
          path: normalizedPath,
          entries: res.entries,
          count: res.count,
        },
        `Directory listed successfully with ${res.count} entry(ies)`
      );
    } catch (error) {
      logger.error(
        { tags: "tools|tandem|listdir|error", color1: "red" },
        `Tandem failed to list directory: ${path}`,
        error
      );
      return this.returnError({}, error.message);
    }
  }
}
